import { Image, Radio } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ThankYouReplySettingsModalWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;

  ${Image.S?.Image} {
    width: 450px;
    object-fit: cover;
  }

  ${Radio?.S?.InputBody} {
    align-items: flex-start;
  }
  ${Radio?.S?.InputCheckmark} {
    margin-top: 2px;
  }
`;

const ExampleThankYouWrapper = styled.div`
  left: 120px;
  max-width: 310px;
  position: absolute;
  top: 90px;
`;

const ExampleThankYou = styled.div`
  background-color: var(--color-bg-weakest2);
  border-radius: var(--size-border-radius-md);
  margin: 16px 0;
  max-width: 310px;
  padding: var(--size-page-padding-sm);
`;

const BottomInfo = styled.div`
  align-items: center;
  display: flex;
  gap: var(--size-gap-6);
  justify-content: center;

  span {
    font-size: 28px;
  }
`;

export {
  BottomInfo,
  ExampleThankYou,
  ExampleThankYouWrapper,
  ItemWrapper,
  ThankYouReplySettingsModalWrapper
};
